// extracted by mini-css-extract-plugin
module.exports = {"text":"TableCell_text__lvwoo"};